<template>
      <div class="bg5 p4">
            <core-form-input
                  componentName="j-base-input-text"
                  name="name"
                  :label="$t('name')"
                  v-validate="'required'"
                  v-model="form.name"
                  :validationErrors="errors"
            />
            <core-form-input
                  componentName="j-base-input-text"
                  name="comment"
                  class="mt6"
                  :label="$t('comment')"
                  v-model="form.comment"
                  :validationErrors="errors"
            />
            <core-form-input
                  componentName="j-base-input-number"
                  name="amount"
                  class="mt6"
                  :label="$t('amount')"
                  v-validate="'required'"
                  v-model="form.amount"
                  :validationErrors="errors"
            />
            <core-form-input
                  componentName="j-base-select"
                  name="currency"
                  class="mt6"
                  :label="$t('currency')"
                  :options="currencies"
                  v-validate="'required'"
                  v-model="form.currencyCode"
                  :validationErrors="errors"
            />
            <core-form-input
                  componentName="j-base-select"
                  name="method"
                  class="mt6"
                  :label="$t('payment_method')"
                  :options="paymentMethods"
                  v-validate="'required'"
                  v-model="form.method"
                  :validationErrors="errors"
            />
            <core-form-input
                  componentName="j-base-select"
                  name="frequency"
                  class="mt6"
                  :label="$t('payment_frequency')"
                  :options="paymentFrequency"
                  v-validate="'required'"
                  v-model="form.frequency"
                  :validationErrors="errors"
            />

            <!-- Buttons -->
            <div class="flex xs-between mt6">
                  <j-button :isLoading="isLoading" @click="handleSave">{{ $t("save") }}</j-button>
                  <j-button @click="handleCancel" type="bordered">{{ $t("cancel") }}</j-button>
            </div>
      </div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import { currencies, paymentMethods, paymentFrequency } from "@/forms/enums.js"
import api from "../api/"

export default {
	components: {
		CoreFormInput,
		JButton
	},

	props: {
		id: String,
		type: String,
		name: String,
		comment: String,
		amount: Number,
		method: String,
		frequency: String,
		currencyCode: String
	},

	data() {
		return {
			isLoading: false,
			form: {
				name: "",
				comment: "",
				amount: "",
				method: "",
				frequency: "",
				currencyCode: this.$store.state.settings
					.preferredCurrency
			},
			currencies: currencies,
			paymentMethods: paymentMethods,
			paymentFrequency: paymentFrequency
		}
	},

	methods: {
		async handleSave() {
			// Validate
			const isValid = await this.$validator.validate()
			if (!isValid) {
				this.$store.dispatch("showError", [
					"There are some missing or incorrect fields in the form"
				])
				return
			}

			if (this.type === "" || this.type === null) return
			if (this.type === "add") this.addPayment()
			if (this.type === "update") this.updatePayment()
		},
		async addPayment() {
			const policyId = this.$route.params.id
			const input = { ...this.form }
			this.isLoading = true

			const res = await api.addPaymentInfo({ policyId, input })

			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.$emit("added")
		},

		async updatePayment() {
			const id = this.$route.params.id
			const paymentId = this.id
			const updateIssuedPaymentInput = { ...this.form }
			this.isLoading = true

			const res = await api.updatePaymentInfo({
				id,
				paymentId,
				updateIssuedPaymentInput
			})

			this.isLoading = false

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			this.$emit("updated")
		},

		handleCancel() {
			this.$emit("cancelled")
		},

		initialize() {
			if (this.type === "add") return

			this.form = {
				name: this.name,
				comment: this.comment,
				amount: this.amount,
				currencyCode: this.currencyCode,
				method: this.method,
				frequency: this.frequency
			}
		}
	},

	mounted() {
		this.initialize()
	}
}
</script>
